"use strict";
/**
 * Skin Report API Types
 *
 * Response types for skin report API endpoints.
 * Used by both backend (tRPC responses) and frontend (data fetching).
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=api.js.map